export default "__VITE_ASSET__1448fbdf__"